import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImac: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="imac, computer"><path d="M6.75 3C4.12665 3 2 5.12665 2 7.75V12.5H22V7.75C22 5.12665 19.8734 3 17.25 3H6.75Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M6.75 18C4.38185 18 2.41846 16.267 2.05888 14H21.9411C21.5815 16.267 19.6182 18 17.25 18H15V21.25C15 21.6642 14.6642 22 14.25 22H9.75C9.33579 22 9 21.6642 9 21.25V18H6.75ZM10.5 18V20.5H13.5V18H10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconImac;
